<div class="report-cases-content container2">
    <form [formGroup]="dateRangeForm">
        <div class="date-range-container">
            <div class="form-group horizontal-form-group">
                <div class="vertical-form-group">
                    <input id="beging" formControlName="beging" class="form-control"
                        [max]="dateRangeForm.value.end" (click)="dpb.open()"
                        [matDatepicker]="dpb" placeholder="Fecha desde:" readonly />
                    <mat-datepicker-toggle matSuffix [for]="dpb"></mat-datepicker-toggle>
                    <mat-datepicker #dpb></mat-datepicker>
                </div>
                <div *ngIf="f.beging.touched && f.beging.errors" class="alert alert-danger error-message">
                    <div *ngIf="f.beging.errors.required">La fecha de inicio es obligatoria.</div>
                </div>
            </div>
    
            <div class="form-group horizontal-form-group">
                <div class="vertical-form-group">
                    <input id="end" formControlName="end" class="form-control"
                        [min]="dateRangeForm.value.beging" (click)="dpe.open()"
                        [matDatepicker]="dpe" placeholder="Fecha hasta:" readonly />
                    <mat-datepicker-toggle matSuffix [for]="dpe"></mat-datepicker-toggle>
                    <mat-datepicker #dpe></mat-datepicker>
                </div>
    
                <div *ngIf="f.end.touched && f.end.errors" class="alert alert-danger error-message">
                    <div *ngIf="f.end.errors.required">La fecha de fin es obligatoria.</div>
                    <div *ngIf="f.end.errors.fechaInvalida">La fecha de fin no puede ser anterior a la de inicio.</div>
                </div>
            </div>
            <div class="form-group horizontal-form-group select-view-container" *ngIf="!verGraficas">
                <select id="code" formControlName="code" class="form-control" placeholder="Selecciona una opción">
                    <option *ngFor="let option of viewOptions" [value]="option.value">
                        {{ option.label }}
                    </option>
                </select>
            </div>
            <button type="submit" [disabled]="dateRangeForm.invalid" class="btn maxh40" 
                [class]="dateRangeForm.invalid ? 'disabled' : 'btn-report-search'" (click)="onSubmit()">
                <i class="fas fa-search"></i> Buscar
            </button>
            <button type="submit" class="btn btn-report-options maxh40" (click)="cambiarVista()">
                <i class="fas fa-calendar"></i> {{ verGraficas ? 'Ver Reportes' : 'ver Gráficos' }}
            </button>
        </div>
    
        <div *ngIf="dateRangeForm.errors?.limiteAnualExcedido && dateRangeForm.touched" class="alert alert-danger">
            El rango de fechas no puede exceder de un año.
        </div>
    </form>
    <div class="table-info-report"
            *ngIf="!verGraficas && infoAll.length>1">
        <file-excel-show-view 
            [isExternal]="false"
            [data]="infoAll"
        ></file-excel-show-view>
    </div>
    <div class="charts-wrapper" *ngIf="contadorService==0 && verGraficas">
        <div class="chart-container" *ngFor="let chart of charts">
            <h2>{{chart.chartName}}</h2>
            <canvas
                baseChart
                [datasets]="chart.chartData"
                [labels]="chart.chartLabels"
                [chartType]="chart.chartType"
                [options]="chart.chartOptions"
                [legend]="chart.chartLegend">
            </canvas>
        </div>
    </div>
</div>